import { render, staticRenderFns } from "./MasterSearchBox.vue?vue&type=template&id=80994ff4&"
import script from "./MasterSearchBox.vue?vue&type=script&lang=js&"
export * from "./MasterSearchBox.vue?vue&type=script&lang=js&"
import style0 from "./MasterSearchBox.vue?vue&type=style&index=0&id=80994ff4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports